<div
  *transloco="let transloco"
  [ngClass]="{
    'flex-row gap-6': this.props.isHorizontal,
    'flex-col': !this.props.isHorizontal
  }"
  class="flex">
  @for (option of (this.props.options | formlySelectOptions: this.field | async)!; track option) {
    <div class="flex min-h-9 items-center gap-2">
      <p-radioButton
        [ngClass]="{
          'ng-dirty ng-invalid p-invalid': this.showError
        }"
        [formControl]="this.formControl"
        [inputId]="this.id + '_' + option['value']"
        [value]="option['value']"
        [formlyAttributes]="this.field"></p-radioButton>
      <label [for]="this.id + '_' + option['value']"> {{ transloco(option['label']) }}</label>
    </div>
  }
</div>
